export default __webpack_public_path__ + "static/media/step4.aba42216.webp";